'use client';

import { theme } from 'components';
import { AdvisorSection, RelatedAdvisorSection } from 'components/advisor';

import styles from './advisor-client.module.css';

export default function Advisor({ advisorId }: { advisorId: string }) {
  return (
    <main
      style={{
        backgroundColor: theme.colors.background,
        color: theme.colors.primary,
      }}
    >
      <AdvisorSection advisorId={advisorId} />
      <div className={`${styles.divider} u-grid`}>
        <div></div>
      </div>
      <RelatedAdvisorSection advisorId={advisorId} />
    </main>
  );
}
